import { render } from "./CreateShadowTeam.vue?vue&type=template&id=669c4a4a"
import script from "./CreateShadowTeam.vue?vue&type=script&lang=js"
export * from "./CreateShadowTeam.vue?vue&type=script&lang=js"

import "./CreateShadowTeam.vue?vue&type=style&index=0&id=669c4a4a&lang=css"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__